import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { LimitReportCompanyListResolver } from '@backoffice-frontend/limit-report/domain';
import { Route, RouterModule } from '@angular/router';
import { FormContainerModule } from '@clean-code/shared/components/ui-form-container';
import { UiMatTableModule } from '@clean-code/shared/components/ui-mat-table';
import { PageContainerModule } from '@clean-code/shared/components/ui-page-container';
import { TranslocoModule } from '@jsverse/transloco';
import { NgxPermissionsModule } from 'ngx-permissions';
import { LimitReportOtherSearchComponent } from '../limit-report-other-search/limit-report-other-search.component';
import { LimitReportOtherListComponent } from './limit-report-list.component';

const routes: Route[] = [
  {
    path: '',
    component: LimitReportOtherListComponent,
    resolve: {
      columns: LimitReportCompanyListResolver,
    },
    children: [
      {
        path: 'preview/:id',
        loadChildren: () =>
          import(
            '../limit-report-list-preview/limit-report-list-preview.module'
          ).then((mod) => mod.LimitReportOtherListPreviewModule),
      },
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),

    MatFormFieldModule,
    MatDividerModule,
    MatRadioModule,

    TranslocoModule,

    FormContainerModule,
    PageContainerModule,
    UiMatTableModule,
    NgxPermissionsModule,
    LimitReportOtherSearchComponent,
  ],
  declarations: [LimitReportOtherListComponent],
  exports: [LimitReportOtherListComponent],
})
export class LimitReportOtherListModule {}
